/* tslint:disable */
/* eslint-disable */
/**
 * PravoEu Application API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface Page
 */
export interface Page {
    /**
     * total count of elements
     * @type {number}
     * @memberof Page
     */
    'totalElements': number;
    /**
     * current page number
     * @type {number}
     * @memberof Page
     */
    'number': number;
    /**
     * size of the page
     * @type {number}
     * @memberof Page
     */
    'size': number;
}
/**
 * 
 * @export
 * @interface PdfPriloha
 */
export interface PdfPriloha {
    /**
     * 
     * @type {string}
     * @memberof PdfPriloha
     */
    'uuid'?: string;
    /**
     * 
     * @type {number}
     * @memberof PdfPriloha
     */
    'size'?: number;
    /**
     * 
     * @type {string}
     * @memberof PdfPriloha
     */
    'fileName'?: string;
}
/**
 * 
 * @export
 * @interface PravoEuDetail
 */
export interface PravoEuDetail {
    /**
     * 
     * @type {string}
     * @memberof PravoEuDetail
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof PravoEuDetail
     */
    'celex'?: string;
    /**
     * 
     * @type {string}
     * @memberof PravoEuDetail
     */
    'nazovPredpisu'?: string;
    /**
     * 
     * @type {string}
     * @memberof PravoEuDetail
     */
    'datumSchvalenia'?: string;
    /**
     * 
     * @type {string}
     * @memberof PravoEuDetail
     */
    'datumUcinnostiOd'?: string;
    /**
     * 
     * @type {string}
     * @memberof PravoEuDetail
     */
    'datumUcinnostiDo'?: string;
    /**
     * 
     * @type {string}
     * @memberof PravoEuDetail
     */
    'datumUverejnenia'?: string;
    /**
     * 
     * @type {string}
     * @memberof PravoEuDetail
     */
    'datumUzavierky'?: string;
    /**
     * 
     * @type {string}
     * @memberof PravoEuDetail
     */
    'datumTranspozicie'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PravoEuDetail
     */
    'zoznamEurovocTerminov'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PravoEuDetail
     */
    'zoznamAutorov'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PravoEuDetail
     */
    'zoznamTypov'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PravoEuDetail
     */
    'zoznamZmluv'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PravoEuDetail
     */
    'zoznamPravnychZakladov'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PravoEuDetail
     */
    'zoznamAdresatovPredpisu'?: Array<string>;
}
/**
 * 
 * @export
 * @interface PravoEuDetailResponse
 */
export interface PravoEuDetailResponse {
    /**
     * 
     * @type {PravoEuDetail}
     * @memberof PravoEuDetailResponse
     */
    'predpisEurlex'?: PravoEuDetail;
    /**
     * 
     * @type {string}
     * @memberof PravoEuDetailResponse
     */
    'htmlContent'?: string;
    /**
     * 
     * @type {Array<PdfPriloha>}
     * @memberof PravoEuDetailResponse
     */
    'pdfPrilohaList'?: Array<PdfPriloha>;
}
/**
 * 
 * @export
 * @interface PravoEuFilter
 */
export interface PravoEuFilter {
    /**
     * 
     * @type {string}
     * @memberof PravoEuFilter
     */
    'hladanyVyraz'?: string;
    /**
     * 
     * @type {string}
     * @memberof PravoEuFilter
     */
    'celex'?: string;
    /**
     * 
     * @type {number}
     * @memberof PravoEuFilter
     */
    'rokUverejnenia'?: number;
    /**
     * 
     * @type {string}
     * @memberof PravoEuFilter
     */
    'eurovoc'?: string;
    /**
     * 
     * @type {string}
     * @memberof PravoEuFilter
     */
    'typNazov'?: string;
    /**
     * 
     * @type {string}
     * @memberof PravoEuFilter
     */
    'autorNazov'?: string;
    /**
     * 
     * @type {string}
     * @memberof PravoEuFilter
     */
    'zmluva'?: string;
    /**
     * 
     * @type {string}
     * @memberof PravoEuFilter
     */
    'datumUverejneniaOd'?: string;
    /**
     * 
     * @type {string}
     * @memberof PravoEuFilter
     */
    'datumUverejneniaDo'?: string;
    /**
     * 
     * @type {string}
     * @memberof PravoEuFilter
     */
    'datumSchvaleniaOd'?: string;
    /**
     * 
     * @type {string}
     * @memberof PravoEuFilter
     */
    'datumSchvaleniaDo'?: string;
    /**
     * 
     * @type {string}
     * @memberof PravoEuFilter
     */
    'datumUcinnostiOdOd'?: string;
    /**
     * 
     * @type {string}
     * @memberof PravoEuFilter
     */
    'datumUcinnostiOdDo'?: string;
    /**
     * 
     * @type {string}
     * @memberof PravoEuFilter
     */
    'datumUcinnostiDoOd'?: string;
    /**
     * 
     * @type {string}
     * @memberof PravoEuFilter
     */
    'datumUcinnostiDoDo'?: string;
    /**
     * 
     * @type {string}
     * @memberof PravoEuFilter
     */
    'datumUzavierkyOd'?: string;
    /**
     * 
     * @type {string}
     * @memberof PravoEuFilter
     */
    'datumUzavierkyDo'?: string;
    /**
     * 
     * @type {string}
     * @memberof PravoEuFilter
     */
    'datumTranspozicieOd'?: string;
    /**
     * 
     * @type {string}
     * @memberof PravoEuFilter
     */
    'datumTranspozicieDo'?: string;
}
/**
 * 
 * @export
 * @interface PravoEuItem
 */
export interface PravoEuItem {
    /**
     * 
     * @type {string}
     * @memberof PravoEuItem
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof PravoEuItem
     */
    'celex'?: string;
    /**
     * 
     * @type {string}
     * @memberof PravoEuItem
     */
    'datumUverejnenia'?: string;
    /**
     * 
     * @type {string}
     * @memberof PravoEuItem
     */
    'typ'?: string;
    /**
     * 
     * @type {string}
     * @memberof PravoEuItem
     */
    'nazov'?: string;
}
/**
 * 
 * @export
 * @interface PravoEuListPage
 */
export interface PravoEuListPage {
    /**
     * total count of elements
     * @type {number}
     * @memberof PravoEuListPage
     */
    'totalElements': number;
    /**
     * current page number
     * @type {number}
     * @memberof PravoEuListPage
     */
    'number': number;
    /**
     * size of the page
     * @type {number}
     * @memberof PravoEuListPage
     */
    'size': number;
    /**
     * 
     * @type {Array<PravoEuItem>}
     * @memberof PravoEuListPage
     */
    'predpisList'?: Array<PravoEuItem>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const SortDirectionEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;

export type SortDirectionEnum = typeof SortDirectionEnum[keyof typeof SortDirectionEnum];



/**
 * PravoEuDetailApi - axios parameter creator
 * @export
 */
export const PravoEuDetailApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get detail of pravoEu.
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPravoEuDetail: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getPravoEuDetail', 'uuid', uuid)
            const localVarPath = `/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PravoEuDetailApi - functional programming interface
 * @export
 */
export const PravoEuDetailApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PravoEuDetailApiAxiosParamCreator(configuration)
    return {
        /**
         * Get detail of pravoEu.
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPravoEuDetail(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PravoEuDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPravoEuDetail(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PravoEuDetailApi.getPravoEuDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PravoEuDetailApi - factory interface
 * @export
 */
export const PravoEuDetailApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PravoEuDetailApiFp(configuration)
    return {
        /**
         * Get detail of pravoEu.
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPravoEuDetail(uuid: string, options?: any): AxiosPromise<PravoEuDetailResponse> {
            return localVarFp.getPravoEuDetail(uuid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PravoEuDetailApi - object-oriented interface
 * @export
 * @class PravoEuDetailApi
 * @extends {BaseAPI}
 */
export class PravoEuDetailApi extends BaseAPI {
    /**
     * Get detail of pravoEu.
     * @param {string} uuid Primary key of entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PravoEuDetailApi
     */
    public getPravoEuDetail(uuid: string, options?: RawAxiosRequestConfig) {
        return PravoEuDetailApiFp(this.configuration).getPravoEuDetail(uuid, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PravoEuListApi - axios parameter creator
 * @export
 */
export const PravoEuListApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get filtered pravo eu list.
         * @param {PravoEuFilter} pravoEuFilter 
         * @param {number} [page] Page number to return, indexed from one.
         * @param {number} [size] Size of page to return.
         * @param {string} [sortBy] 
         * @param {SortDirectionEnum} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPravoEuFilteredList: async (pravoEuFilter: PravoEuFilter, page?: number, size?: number, sortBy?: string, sortDirection?: SortDirectionEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pravoEuFilter' is not null or undefined
            assertParamExists('getPravoEuFilteredList', 'pravoEuFilter', pravoEuFilter)
            const localVarPath = `/filter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pravoEuFilter, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PravoEuListApi - functional programming interface
 * @export
 */
export const PravoEuListApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PravoEuListApiAxiosParamCreator(configuration)
    return {
        /**
         * Get filtered pravo eu list.
         * @param {PravoEuFilter} pravoEuFilter 
         * @param {number} [page] Page number to return, indexed from one.
         * @param {number} [size] Size of page to return.
         * @param {string} [sortBy] 
         * @param {SortDirectionEnum} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPravoEuFilteredList(pravoEuFilter: PravoEuFilter, page?: number, size?: number, sortBy?: string, sortDirection?: SortDirectionEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PravoEuListPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPravoEuFilteredList(pravoEuFilter, page, size, sortBy, sortDirection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PravoEuListApi.getPravoEuFilteredList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PravoEuListApi - factory interface
 * @export
 */
export const PravoEuListApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PravoEuListApiFp(configuration)
    return {
        /**
         * Get filtered pravo eu list.
         * @param {PravoEuFilter} pravoEuFilter 
         * @param {number} [page] Page number to return, indexed from one.
         * @param {number} [size] Size of page to return.
         * @param {string} [sortBy] 
         * @param {SortDirectionEnum} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPravoEuFilteredList(pravoEuFilter: PravoEuFilter, page?: number, size?: number, sortBy?: string, sortDirection?: SortDirectionEnum, options?: any): AxiosPromise<PravoEuListPage> {
            return localVarFp.getPravoEuFilteredList(pravoEuFilter, page, size, sortBy, sortDirection, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PravoEuListApi - object-oriented interface
 * @export
 * @class PravoEuListApi
 * @extends {BaseAPI}
 */
export class PravoEuListApi extends BaseAPI {
    /**
     * Get filtered pravo eu list.
     * @param {PravoEuFilter} pravoEuFilter 
     * @param {number} [page] Page number to return, indexed from one.
     * @param {number} [size] Size of page to return.
     * @param {string} [sortBy] 
     * @param {SortDirectionEnum} [sortDirection] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PravoEuListApi
     */
    public getPravoEuFilteredList(pravoEuFilter: PravoEuFilter, page?: number, size?: number, sortBy?: string, sortDirection?: SortDirectionEnum, options?: RawAxiosRequestConfig) {
        return PravoEuListApiFp(this.configuration).getPravoEuFilteredList(pravoEuFilter, page, size, sortBy, sortDirection, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PrilohaDownloadApi - axios parameter creator
 * @export
 */
export const PrilohaDownloadApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Download priloha by id
         * @param {string} prilohaUuid Primary key of attachment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPriloha: async (prilohaUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'prilohaUuid' is not null or undefined
            assertParamExists('downloadPriloha', 'prilohaUuid', prilohaUuid)
            const localVarPath = `/prilohy/{prilohaUuid}`
                .replace(`{${"prilohaUuid"}}`, encodeURIComponent(String(prilohaUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PrilohaDownloadApi - functional programming interface
 * @export
 */
export const PrilohaDownloadApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PrilohaDownloadApiAxiosParamCreator(configuration)
    return {
        /**
         * Download priloha by id
         * @param {string} prilohaUuid Primary key of attachment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadPriloha(prilohaUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadPriloha(prilohaUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrilohaDownloadApi.downloadPriloha']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PrilohaDownloadApi - factory interface
 * @export
 */
export const PrilohaDownloadApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PrilohaDownloadApiFp(configuration)
    return {
        /**
         * Download priloha by id
         * @param {string} prilohaUuid Primary key of attachment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPriloha(prilohaUuid: string, options?: any): AxiosPromise<string> {
            return localVarFp.downloadPriloha(prilohaUuid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PrilohaDownloadApi - object-oriented interface
 * @export
 * @class PrilohaDownloadApi
 * @extends {BaseAPI}
 */
export class PrilohaDownloadApi extends BaseAPI {
    /**
     * Download priloha by id
     * @param {string} prilohaUuid Primary key of attachment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrilohaDownloadApi
     */
    public downloadPriloha(prilohaUuid: string, options?: RawAxiosRequestConfig) {
        return PrilohaDownloadApiFp(this.configuration).downloadPriloha(prilohaUuid, options).then((request) => request(this.axios, this.basePath));
    }
}



